import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "container", "connector" ]

  addOperation(event) {
    event.preventDefault();
    const $operationSelect = $("#operation_select_" + $(this.connectorTarget).find(":selected").val());
    let html = "<tr>";
    html += "<td><input type='hidden' name='app_assistant[operation_ids][]' value='" + $operationSelect.find(":selected").val() + "'>";
    html += $(this.connectorTarget).find(":selected").text();
    html += "</td>";
    html += "<td>" + $operationSelect.find(":selected").text() + "</td>"
    html += "<td class='text-end'><a class='link-danger' href='' data-action='function-tools#removeOperation'>Remove</a></td>";
    html += "</tr>";
    $(this.containerTarget).append(html);
  }

  removeOperation(event) {
    event.preventDefault();
    $(event.target).closest('tr').remove();
  }

}
